import React from 'react';
import { FeatureCallout } from '../common/FeatureElements';
import { Copy, Flexer, Title } from '../dashboard/elements/LayoutElements';
import { UpgradeButton } from '../upgrade/UpgradeButton';

export const WorkspaceFeatureCallout = () =>
    <Flexer inset flex center zIndex="1">
        <FeatureCallout maxWidth="64">
            <Title>Workspaces are a Premium feature.</Title>
            <Copy>
                In order to create and manage Workspaces, your organization must be on a paid plan.
                Workspaces allow you to better organize your boards as well as provide a level of access control within your team space.
            </Copy>
            <UpgradeButton variant="common" />
        </FeatureCallout>
    </Flexer>;
